module.exports = __webpack_public_path__ + "img/classe4.63b7ace9.jpg";